import { render, staticRenderFns } from "./TableMusicYx.vue?vue&type=template&id=2d80b304&scoped=true&"
import script from "./TableMusicYx.vue?vue&type=script&lang=js&"
export * from "./TableMusicYx.vue?vue&type=script&lang=js&"
import style0 from "./TableMusicYx.vue?vue&type=style&index=0&id=2d80b304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d80b304",
  null
  
)

export default component.exports